/**
 * DevExtreme (esm/ui/select_box.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import SelectBox from "../__internal/ui/m_select_box";
export default SelectBox;
